// extracted by mini-css-extract-plugin
module.exports = {"root":"eTgOF","title":"_1nlyc","body":"_23gBX"};